export const PLATFORMS = {
  CRM: 'CRM',
  PERSPECTIVE: 'PERSPECTIVE',
  SETTINGS: 'SETTINGS',
  INSIGHTS: 'INSIGHTS',
  UNISON: 'UNISON',
} as const;
